module.exports = __webpack_public_path__ + "media/images/splash-screen/onboarding3-172fdc17277b8dc031acf7c24e530cfb.png";